import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp } from "lucide-react";

interface ShowMoreProps {
  lines?: number;
  showButton?: boolean;
  children: React.ReactNode;
}

export const ShowMore = ({
  lines = 5,
  showButton = true,
  children,
}: ShowMoreProps) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div>
      <div
        className={showMore ? "" : "overflow-hidden"}
        style={
          showMore
            ? undefined
            : {
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: lines,
              }
        }
      >
        {children}
      </div>
      {showButton && (
        <Button
          variant="ghost"
          size="lg"
          className="mt-4"
          onClick={() => setShowMore(!showMore)}
        >
          {showMore ? "Show Less" : "Show More"}
          {showMore ? <ChevronUp /> : <ChevronDown />}
        </Button>
      )}
    </div>
  );
};
